// 公告管理
export default [
  {
    path: "/announcement",
    name: "announcement",
    meta: { title: "公告管理" },
    component: () => import("../views/announcement/index"),
    children: [
      {
        path: "/announcement/list",
        name: "announcementList",
        meta: { title: "公告管理列表", isMenu: true },
        component: () => import("../views/announcement/list"),
      },
      {
        path: "/announcement/list/details",
        name: "announcementDetails",
        meta: { title: "公告管理详情" },
        component: () => import("../views/announcement/detail/details"),
      },
    ],
  },
]